/**
 * @file vuexstore for states used by the active draft post composer modal
 */
import { DockableModalState } from 'types'
import { Module } from 'vuex'
import { RootState } from 'vuexstore/surface/types'

interface ComposerModalState {
  modalState: DockableModalState
  scrolledToTop: boolean
  scrolledToBottom: boolean
}

const initialState = (): ComposerModalState => {
  return {
    modalState: 'expanded',
    scrolledToTop: false,
    scrolledToBottom: false,
  }
}

const composerModal: Module<ComposerModalState, RootState> = {
  namespaced: true,
  state: initialState(),
  getters: {
    modalState: (state): DockableModalState => state.modalState,
    isDocked: (state): boolean => state.modalState === 'docked',
    isExpanded: (state): boolean => state.modalState === 'expanded',
    scrolledToTop: (state): boolean => state.scrolledToTop,
    scrolledToBottom: (state): boolean => state.scrolledToBottom,
  },
  mutations: {
    DOCK_MODAL(state): void {
      state.modalState = 'docked'
    },
    EXPAND_MODAL(state): void {
      state.modalState = 'expanded'
    },
    UPDATE_SCROLL_POSITION(state, { scrolledToTop, scrolledToBottom }): void {
      state.scrolledToTop = scrolledToTop
      state.scrolledToBottom = scrolledToBottom
    },
  },
  actions: {
    dock({ commit }): void {
      commit('DOCK_MODAL')
    },
    expand({ commit }): void {
      commit('EXPAND_MODAL')
    },
    updateScrollPosition({ commit }, { scrolledToTop, scrolledToBottom }): void {
      commit('UPDATE_SCROLL_POSITION', { scrolledToTop, scrolledToBottom })
    },
  },
}

export default composerModal
export { ComposerModalState }
